import { FETCH_INTERVENTIONS } from '../actionTypes/reading/apiActionTypes';
import interventionsParser from './interventionsReducerParsers';

export const initialState = {
    data: {},
    isInterventionsDataFetching: false,
    error: null,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case FETCH_INTERVENTIONS.START:
            return {
                ...state,
                isInterventionsDataFetching: true,
            };
        case FETCH_INTERVENTIONS.SUCCESS:
            return {
                ...state,
                data: interventionsParser(action.response),
                isInterventionsDataFetching: false,
            };
        case FETCH_INTERVENTIONS.ERROR:
            return { ...state, data: {}, error: action.error, isInterventionsDataFetching: false };
        default:
            return state;
    }
};

const getInterventions = state => state.data;

const isInterventionsDataFetching = state => state.isInterventionsDataFetching;

export const selectors = {
    getInterventions,
    isInterventionsDataFetching,
};
